import { render, staticRenderFns } from "./Descargar.vue?vue&type=template&id=3b6bcd95&scoped=true&"
import script from "./Descargar.vue?vue&type=script&lang=ts&"
export * from "./Descargar.vue?vue&type=script&lang=ts&"
import style0 from "./Descargar.vue?vue&type=style&index=0&id=3b6bcd95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bcd95",
  null
  
)

export default component.exports